// extracted by mini-css-extract-plugin
module.exports = {"mobileHeaderHeightSection":"92","mobileHeaderHeightTotal":"184","uvBodyFont":"\"itc-avant-garde-gothic-pro\"","projExpandedAnimDuration":".4"};